// extracted by mini-css-extract-plugin
export default {"venue-card-details-main":"VenueDetailsCardMain_venue-card-details-main__DnFYs","venue-card-details-main__wrapper":"VenueDetailsCardMain_venue-card-details-main__wrapper__Z+s4P"};